import types from 'actions/types'

export const getClientSecret = () => ({
  type: types.SUBSCRIPTIONS_GET_CLIENT_SECRET_ATTEMPT,
})

export const getClientSecretSuccess = (clientSecret) => ({
  type: types.SUBSCRIPTIONS_GET_CLIENT_SECRET_SUCCESS,
  clientSecret,
})

export const getClientSecretFailure = (message, code) => ({
  type: types.SUBSCRIPTIONS_GET_CLIENT_SECRET_FAILURE,
  message,
  code,
})

export const addSubscription = (paymentMethodId) => ({
  type: types.SUBSCRIPTIONS_ADD_ATTEMPT,
  paymentMethodId,
})

export const addSubscriptionSuccess = () => ({
  type: types.SUBSCRIPTIONS_ADD_SUCCESS,
})

export const addSubscriptionFailure = (message, code) => ({
  type: types.SUBSCRIPTIONS_ADD_FAILURE,
  message,
  code,
})

export const cancelSubscription = (cancellationReason, cancellationNotes) => ({
  type: types.SUBSCRIPTIONS_CANCEL_ATTEMPT,
  cancellationReason,
  cancellationNotes,
})

export const cancelSubscriptionSuccess = (paymentDue, cancelDate) => ({
  type: types.SUBSCRIPTIONS_CANCEL_SUCCESS,
  paymentDue,
  cancelDate,
})

export const cancelSubscriptionFailure = (message, code) => ({
  type: types.SUBSCRIPTIONS_CANCEL_FAILURE,
  message,
  code,
})

export const loadPaymentMethod = () => ({
  type: types.PAYMENT_METHOD_LOAD_ATTEMPT,
})

export const loadPaymentMethodSuccess = (data) => ({
  type: types.PAYMENT_METHOD_LOAD_SUCCESS, data,
})

export const loadPaymentMethodFailure = (message, code) => ({
  type: types.PAYMENT_METHOD_LOAD_FAILURE,
  message,
  code,
})

export const updatePaymentMethod = (paymentMethodId, callback) => ({
  type: types.PAYMENT_METHOD_UPDATE_ATTEMPT,
  paymentMethodId,
  callback,
})

export const updatePaymentMethodSuccess = () => ({
  type: types.PAYMENT_METHOD_UPDATE_SUCCESS,
})

export const updatePaymentMethodFailure = (message, code) => ({
  type: types.PAYMENT_METHOD_UPDATE_FAILURE,
  message,
  code,
})

export const getPrice = (accountPackages) => ({
  type: types.SUBSCRIPTIONS_GET_PRICE_ATTEMPT,
  accountPackages,
})

export const getPriceSuccess = (planPrices) => ({
  type: types.SUBSCRIPTIONS_GET_PRICE_SUCCESS,
  planPrices,
})

export const getPriceFailure = (message, code) => ({
  type: types.SUBSCRIPTIONS_GET_PRICE_FAILURE,
  message,
  code,
})

export const loadUpcomingInvoice = () => ({
  type: types.SUBSCRIPTIONS_LOAD_UPCOMING_INVOICE_ATTEMPT,
})

export const loadUpcomingInvoiceSuccess = (data) => ({
  type: types.SUBSCRIPTIONS_LOAD_UPCOMING_INVOICE_SUCCESS,
  data,
})

export const loadUpcomingInvoiceFailure = (message, code) => ({
  type: types.SUBSCRIPTIONS_LOAD_UPCOMING_INVOICE_FAILURE,
  message,
  code,
})

export const getCancellationDate = () => ({ type: types.SUBSCRIPTIONS_GET_CANCEL_DATE_ATTEMPT })
export const getCancellationDateSuccess = (cancelDate) => ({ type: types.SUBSCRIPTIONS_GET_CANCEL_DATE_SUCCESS, cancelDate })
export const getCancellationDateFailure = (message, code) => ({ type: types.SUBSCRIPTIONS_GET_CANCEL_DATE_FAILURE, message, code })